import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-24 px-4 md:px-10">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">Popular</span>
            <span className="text-3xl md:text-4xl font-heading italic text-primary-500 font-bold">Categories</span>
          </div>
          <p className="text-foreground-500 text-sm md:text-base max-w-md">
            Browse through organized product categories to find exactly what you are looking for
          </p>
        </div>
        <span className="inline-block mt-3 md:mt-0 px-4 py-2 bg-foreground-900 text-background-50 rounded-full text-xs font-semibold whitespace-nowrap">
          14 Categories
        </span>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-4 md:gap-5">
        {categories.map((cat) => (
          <a
            key={cat.slug}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-accent-50 transition-all duration-300 flex flex-col"
            data-product-shop
          >
            {/* Image */}
            <div className="relative w-full aspect-square overflow-hidden">
              <img
                src={cat.imageUrl}
                alt={`Superbuy Spreadsheet ${cat.name} category`}
                title={`Superbuy Spreadsheet ${cat.name} - ${cat.description}`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            {/* Info */}
            <div className="p-3 md:p-4 flex flex-col flex-1">
              <span className="text-xs text-foreground-400 uppercase tracking-wide">{cat.description}</span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1 leading-tight">{cat.name}</h3>
              <span className="text-xs font-bold text-accent-600 mt-auto pt-2">{cat.count}</span>
            </div>
          </a>
        ))}
      </div>

      {/* Bottom CTA */}
      <div className="text-center mt-12">
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
        >
          Superbuy Sheet
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}